import React, { Component } from "react"
import I18n from "../../utils/i18n.js"
import ReactDOM from "react-dom"
import AdvancedFacetMixin from '../mixins/advanced_facet_mixin'
import createReactClass from 'create-react-class'

export default createReactClass({
  mixins: [AdvancedFacetMixin],

  getInitialState() {
    return {autocomplete: null};
  },

  getDefaultProps() {
    return {
      form: null,
      map: null,
      filters: [],
      options: {},
      general_inputs:
        ['allows_pets', 'free_standing', 'table_d_hotes', 'is_studio', 'is_appartment', 'is_houseboat', 'is_roulotte',
         'is_safaritent', 'is_treehouse', 'wheelchair_accessible', 'is_large_groups', 'non_smoking', 'adults_only', 'has_local_contact'],
      location_inputs:
        ['on_camping', 'on_vineyard', 'on_farm', 'near_country_side', 'near_village', 'near_city',
          'near_hills', 'near_mountains', 'near_public_transport'],
      facility_inputs:
        ['has_private_pool', 'has_heated_pool', 'has_pool_inside', 'has_tennis_at_object', 'has_bike_at_object',
          'has_course_room', 'has_child_bed', 'has_child_chair', 'is_children_safe', 'has_babysitter',
          'has_playing_room_outside', 'has_tv', 'has_sauna', 'has_jacuzzi', 'has_dishwasher', 'has_washing_machine',
          'has_vegetable_garden', 'has_fenced_garden', 'has_boat_at_object', 'has_airco'],
      activity_inputs:
        ['near_themepark', 'has_activities_program', 'near_bike', 'near_mountainbike', 'near_hiking',
          'near_horseriding', 'near_watersports', 'near_fishsport', 'near_mountainsports', 'near_flying',
          'has_painting_course', 'has_pottery', 'has_yoga', 'has_cooking_course', 'has_language_course', 'has_other_courses']
    };
  },

  render() {
    const self = this;

    const general_inputs = [];

    ['bedrooms', 'bathrooms'].map(function(filter) {
      const options = [1, 2, 3, 4, 5].map(i => {
        return { value: i, label: I18n.t(`search.attributes.${filter}`, {count: i})};
      });
      const placeholder = I18n.t(`search.placeholders.${filter}`);
      return general_inputs.push(self.createSelect2Input(filter, options, false, placeholder, 'input--yellow input--small'));
    });

    const general_sub_inputs = this.props.general_inputs.map(filter => self.createInput(filter));

    ['two_person_beds', 'one_person_beds'].map(function(filter) {
      const options = [1, 2, 3, 4, 5].map(i => {
        return { value: i, label: I18n.t(`search.attributes.${filter}`, {count: i})}
      });
      const placeholder = I18n.t(`search.placeholders.${filter}`);
      return general_sub_inputs.push(self.createSelect2Input(filter, options, false, placeholder, 'input--yellow input--small'));
    });

    const location_inputs = ['near_beach', 'near_water'].map(filter => self.createInput(filter));
    const location_sub_inputs = this.props.location_inputs.map(filter => self.createInput(filter));

    const facility_inputs = ['has_swimmingpool', 'has_internet'].map(filter => self.createInput(filter));
    const facility_sub_inputs = this.props.facility_inputs.map(filter => self.createInput(filter));

    const activity_inputs = ['near_skiing', 'has_golfcourse'].map(filter => self.createInput(filter));
    const activity_sub_inputs = this.props.activity_inputs.map(filter => self.createInput(filter));

    const general    = this.createSubForm(I18n.t('search.form_labels.general'), general_inputs, general_sub_inputs, 'general');
    const location   = this.createSubForm(I18n.t('search.form_labels.location'), location_inputs, location_sub_inputs, 'location');
    const facilities = this.createSubForm(I18n.t('search.form_labels.facilities'), facility_inputs, facility_sub_inputs, 'facilities');
    const activities = this.createSubForm(I18n.t('search.form_labels.activities'), activity_inputs, activity_sub_inputs, 'activities');
    const areas      = this.generateAreaInputs();

    return <div>
      {general}
      {location}
      {facilities}
      {activities}
      {areas}
    </div>;
  }
});
